import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';

function onClickButton ({toggleMenu,isOpen,inputRef}) {
  return () => toggleMenu(!isOpen && (inputRef.current.focus()))
}

export default function Button (props) {
  const {
    clearSelection,
    selectedItem,
    getToggleButtonProps,
    isOpen,
  } = props;
  const onClick = onClickButton(props);
  return selectedItem ? (
    <IconButton
      onClick={clearSelection}
      aria-label="clear selection"
    >
      <ClearIcon />
    </IconButton>
  ) : (
    <IconButton {...getToggleButtonProps()} onClick={onClick}>
      <ArrowDropDown isOpen={isOpen} style={isOpen ? {transform:"rotate(180deg)"}:{}} />
    </IconButton>
  )
}
